/**
 * How long Send waits for an Undo, per browser like the look and mode.
 * The wait is the only delay a person sees between Send and "Message sent."
 * (the server part is a fraction of a second), so it is theirs to choose.
 */

export const UNDO_CHOICES = [0, 5, 10, 20] as const;
export type UndoSeconds = (typeof UNDO_CHOICES)[number];

const KEY = 'zitimail.undoSend';
const DEFAULT: UndoSeconds = 5;

export function undoSeconds(): UndoSeconds {
  try {
    const n = Number(window.localStorage.getItem(KEY));
    return (UNDO_CHOICES as readonly number[]).includes(n) &&
      window.localStorage.getItem(KEY) !== null
      ? (n as UndoSeconds)
      : DEFAULT;
  } catch {
    return DEFAULT;
  }
}

export function setUndoSeconds(seconds: UndoSeconds): void {
  try {
    window.localStorage.setItem(KEY, String(seconds));
  } catch {
    // Private window: the choice lasts this page only.
  }
}
